import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

export interface GetCredentialsQueryPayload {
  sellerId: string;
  salesChannelIds: string[];
  signal?: AbortSignal;
}

interface CredentialSummary {
  sellerId: string;
  salesChannelId: string;
  credentials: string;
}

export const getCredentialsQuery = async (
  payload: GetCredentialsQueryPayload,
): Promise<BackResponseFailure | BackResponse<CredentialSummary[]>> => {
  try {
    return await apiCall<BackResponse<CredentialSummary[]>>(
      buildUrl(`${APIConfiguration.marketplace}credentials`, {
        sellerId: payload.sellerId,
        salesChannelIds: payload.salesChannelIds,
      }),
      {
        method: SUPPORTED_METHODS.GET,
        signal: payload.signal,
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
